import gql from 'graphql-tag';

export default gql`
query GetBalances(
        $mnth: Int!
        ) {
    getBalances(input:{
        mnth: $mnth
    }) {
      items {
        mnth
        currency
        users
        amount
      }
    }
}
`;
